module.exports = __webpack_public_path__ + "img/amazon.be7bdb01.svg";